import { configureStore } from "@reduxjs/toolkit";
import React from "react";
import { TypedUseSelectorHook, createDispatchHook, createSelectorHook } from "react-redux";
import novastarSlice from "./novastarSlice";
import megapixelSlice from "./megapixelSlice";
import epicSlice from "./epicSlice";
import ledActionsSlice from "./ledActionsSlice";
import powerbiSlice from "./powerbiSlice";
import tableauSlice from "./tableauSlice";
import servicenowSlice from "./servicenowSlice";
import grafanaSlice from "./grafanaSlice";
import splunkSlice from "./splunkSlice";
import powerpointSlice from "./powerpointSlice";
import domoSlice from "./domoSlice";
import sapSlice from "./sapSlice";
import excelSlice from "./excelSlice";
import genetecSlice from "./genetecSlice";
import everbridgeSlice from "./everbridgeSlice";
import milestoneSlice from "./milestoneSlice";

export const IntegrationContext = React.createContext(null);

const integrationStore = configureStore({
    reducer: {
        novastarStore: novastarSlice,
        megapixelStore: megapixelSlice,
        epicStore: epicSlice,
        ledActionsStore: ledActionsSlice,
        powerbiStore: powerbiSlice,
        tableauStore: tableauSlice,
        servicenowStore: servicenowSlice,
        grafanaStore: grafanaSlice,
        splunkStore: splunkSlice,
        powerpointStore: powerpointSlice,
        domoStore: domoSlice,
        sapStore: sapSlice,
        excelStore: excelSlice,
        genetecStore: genetecSlice,
        everbridgeStore: everbridgeSlice,
        milestoneStore: milestoneSlice,
    },
});
export default integrationStore;

export type State = ReturnType<typeof integrationStore.getState>;
export type Dispatch = typeof integrationStore.dispatch;
export const useIntegrationSelector: TypedUseSelectorHook<State> = createSelectorHook(IntegrationContext);
export const useIntegrationDispatch = createDispatchHook<Dispatch>(IntegrationContext);
